<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-loading"
                 centered
                 hide-header
                 hide-footer>
            <div class="modal-loading-content">
                Loading...
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
// import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AlertModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    data: function() {
        return {
            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        show: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-loading {
        @extend %modal-base;
        .modal-dialog {
            .modal-content {
                background: rgba(0, 0, 0, 0);
                color: #fff;
                font-weight: bold;
                text-align: center;

                .modal-loading-content {
                    max-width: 250px;
                    margin: auto;
                    background: rgba(0, 0, 0, 0.7);
                    border-radius: 10px;
                    padding: 30px 10px;
                }
            }
        }
    }
</style>
